import { Component, OnInit } from '@angular/core';
import { DetalleVenta } from 'src/app/model/index.model';
import { DetalleVentaService } from 'src/app/service/index.service';

@Component({
  selector: 'app-reporte-entrega',
  templateUrl: './reporte-entrega.component.html',
  styleUrls: ['./reporte-entrega.component.css']
})
export class ReporteEntregaComponent implements OnInit {

  items: DetalleVenta[];
  entity = "Entregas";
  fecha = new Date();
  proccess: boolean = true;
  constructor() {
    this.items = [];
  }

  ngOnInit() { }

  doFound(event) {
    this.items = event;
    this.proccess = false
  }

  exportTableToExcel(tableID: string, filename = 'excel_data.xlsx') {
    const dataType = 'application/vnd.ms-excel';

    const tableSelect = document.getElementById(tableID);
    if (!tableSelect) {
      console.error(`Tabla con ID '${tableID}' no encontrada`);
      return;
    }

    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Crear nombre de archivo
    filename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;

    const nav = window.navigator as any;

    if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
      // IE11 o Edge Legacy
      const blob = new Blob(['\ufeff', tableHTML], { type: dataType });
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      // Navegadores modernos
      const downloadLink = document.createElement("a");
      downloadLink.href = `data:${dataType},${tableHTML}`;
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  get totalVendido(): number {
    return this.items?.reduce((sum, item) =>
      sum + (item.cantidad * (item.precio || 0)), 0) || 0;
  }

  get totalGanancia(): number {
    return this.items?.reduce((sum, item) =>
      sum + (item.cantidad * (item.ganancia || 0)), 0) || 0;
  }

}
